<h5 class="text--h5">{{ 'health.health-year-summary.header' | translate }}</h5>
<div class="table-desktop">
  <table
    mat-table
    matSort
    #table
    [dataSource]="dataSource"
    class="table-desktop__table--alternate-rows cust-table"
  >
    @for (column of columnIds(); track column; let colIndex = $index) {
      <ng-container matColumnDef="{{ column }}">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (colIndex !== 1) {
            <div>
              {{ columns[colIndex].label | translate }}
            </div>
          }
          @if (colIndex === 1) {
            <div>
              {{ selectedDate | date: (columns[colIndex].label | translate) }}
            </div>
          }
        </th>
        <td mat-cell *matCellDef="let row">
          @if (columns[colIndex].type === 'string') {
            <div>
              {{ 'health.health-year-summary.group-' + row[column] | translate }}
            </div>
          }
          @if (columns[colIndex].type === 'drill') {
            <div>
              <button
                mat-button
                (click)="openDrillCowList(row[column].cows, row[column].cowsWithAttention)"
              >
                {{ row[column].value }} ({{ row[column].percentage | number: '1.0-0' }}%)
              </button>
            </div>
          }
        </td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
    <tr mat-row *matRowDef="let row; columns: columnIds()"></tr>
  </table>
</div>
